// extracted by mini-css-extract-plugin
export default {"root":"styles-module-root-ca2e06"};